import FormField from 'components/formik/FormField'
import { useFormikContext } from 'formik'
import { useEffect } from 'react'
import { FormValues } from '../OnboardingWizard'

interface CommentFormFieldProps {
  questionKey: string
}

// Required free-text elaboration shown when a chosen answer option has
// comments_required (e.g. source_of_funds 'Other'). Registers its own
// validator while mounted so submission is blocked until it's filled in.
export default function CommentFormField({
  questionKey
}: CommentFormFieldProps) {
  const { registerField, isSubmitting, errors } = useFormikContext<FormValues>()
  const name = `comments.${questionKey}`

  useEffect(() => {
    registerField(name, {
      validate: value =>
        value && String(value).trim() ? undefined : 'This field is required'
    })

    return () => {
      registerField(name, {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        validate: function () {}
      })
    }
  }, [name, registerField])

  const error = errors.comments?.[questionKey]

  return (
    <FormField
      name={name}
      required
      placeholder='Please elaborate...'
      sx={{ ml: 4, width: '90%' }}
      error={!!error}
      helperText={error}
      disabled={isSubmitting}
    />
  )
}
